export default {
	"palette": {
		"primary1Color": "#424242",
		"primary2Color": "#0277bd",
		"accent1Color": "#00b0ff",
		"primary3Color": "#424242"
	}
};


// WEBPACK FOOTER //
// ./src/style/material.js